import React from 'react'
import Highlight from './highlight'

class HighlightSection extends React.Component {
  renderHighlightItems() {
    const { highlights, theme } = this.props
    let topBorderCounter = 0.0
    let leftBorderCounter = 0.0

    const borderStyles = highlights.map((highlight, index) => {
      if (highlight.content.type === 'animatedMap') {
        return 'md:border-l-0'
      }

      const bits = highlight.width.split('/')
      const width = parseInt(bits[0], 10) / parseInt(bits[1], 10)

      const isFirstInRow = leftBorderCounter % 1 === 0
      const isLastInRow = (width + leftBorderCounter) % 1 === 0
      const isTopRow = topBorderCounter < 1
      let style = ''

      if (isTopRow) {
        style += 'md:border-t-0'
      }

      if (isFirstInRow) {
        style += ' lg:pl-20 md:border-l-0'
      }

      if (isLastInRow) {
        style += ' lg:pr-20'
      }

      topBorderCounter += width
      leftBorderCounter += width

      return style
    })

    return highlights.map((highlight, index) => (
      <Highlight
        item={highlight}
        key={`highlight-${index}`}
        styles={borderStyles[index]}
        theme={theme}
      />
    ))
  }

  render() {
    const { highlights } = this.props

    if (!highlights) {
      return null
    }

    return (
      <section data-label="highlights-section">
        <div className="container px-25 md:pb-90">
          <div className="flex flex-wrap">{this.renderHighlightItems()}</div>
        </div>
      </section>
    )
  }
}

export default HighlightSection
